import type { CampaignContract, PlanSlug } from "../api/types";

/**
 * Whether the early-adopter promo may be shown for a plan, for THIS user.
 *
 * True only when the campaign is `active`, the user is `eligible`, and the plan is
 * in `applies_to`. Anonymous users (no campaign), a failed/absent campaign call, or
 * a non-eligible user all yield `false` → the surface renders standard pricing
 * (no mis-sell; the −50% is applied server-side at checkout). See CONTRACT.md / SPEC B.4.
 */
export const isPromoActive = (
  campaign: CampaignContract | null | undefined,
  slug: PlanSlug,
): boolean => {
  if (!campaign) return false;
  return (
    campaign.active && campaign.eligible && campaign.applies_to.includes(slug)
  );
};

/** The promo discount percentage to apply for this plan/user, or null when no promo applies. */
export const promoDiscountPercent = (
  campaign: CampaignContract | null | undefined,
  slug: PlanSlug,
): number | null => {
  if (!isPromoActive(campaign, slug)) return null;
  return campaign?.discount_percent ?? null;
};
